import { AbstractControl } from '@angular/forms';
import { AssetTeam, Scenario } from 'app/shared/models';
import { NameValueInt, NameValueIntParentInt, NameValueIntParentIntFunctionInt } from 'app/shared/models/name-value';

export interface ProjectObject {
  ProjectTypeId?: number;
  OperatingUnitId?: number;
  DivisionId?: number;
  FunctionId?: number;
  AssetTeamId?: number;
}

export interface DrillingCompletionObject {
  DrillDesignId?: number;
  ProjectTypeId?: number;
  ProjectSubTypeId?: number;
  AssetTeamId?: number;
  ProjectId?: number;
  ConstructionTypeId?: number;
  FunctionId?: number;
  OperatingUnitId?: number;
  DivisionId?: number;
  DefaultStandardConfigurationId?: number;
}

export interface DropDownSourceRelation {
  source: NameValueInt[];
  dest: NameValueInt[];
  control: AbstractControl;
  fieldName: string;
}

export interface IProjectSelectors {
  assetTeam: AssetTeam;
  scenario: Scenario;
  projectTeam: NameValueIntParentInt;
  areThereSubtypes: boolean;
  hasProjectTeam: boolean;
  projectTypeId: number;
  projectSubTypeId: number;
  assetTypeId: number;
  exploreDevelopId: number;
}

export class ProjectLists {
  TypeCurveAreaIds: NameValueIntParentInt[] = [];
  ProjectTeamIds: NameValueIntParentIntFunctionInt[] = [];
  BusinessAssociateIds: NameValueInt[] = [];
  TeamRoleIds: NameValueInt[] = []; //TeamRole[],
  WellTypeIds: NameValueInt[] = [];
  WellProfileIds: NameValueInt[] = [];
  TargetFormationIds: NameValueInt[] = [];
  ProjectTypesRequiringWells: NameValueInt[] = [];
  ExploreDevelopIds: NameValueInt[] = [];
}

export class WellFilters implements IWellFilters {

  AssetTypeId: number;
  TargetFormationId: number;
  TypeCurveAreaId: number;
  WellProfileId: number;
  wellName: string;
  wells: ISmallWell[];
  loadingWellTypes: string;
  wellId: number;
  haveWellData: boolean;
  assetId: number;
  well: ISmallWell;
  showingAssets: boolean;
  constructor() {

    this.AssetTypeId = 0;
    this.TargetFormationId = 0;
    this.TypeCurveAreaId = 0;
    this.WellProfileId = 0;
    this.wellName = '';
    this.wells = [];
    this.loadingWellTypes = 'Oil and Gas Wells';
    this.wellId = 0;
    this.haveWellData = false;
    this.assetId = 0;
    this.well = null;
    this.showingAssets = false;
  }
}

export interface IWellFilters {
  AssetTypeId: number;
  TargetFormationId: number;
  TypeCurveAreaId: number;
  WellProfileId: number;
  wellName: string;
  wells: ISmallWell[];
  loadingWellTypes: string;
  wellId: number;
  haveWellData: boolean;
  assetId: number;
  well: ISmallWell;
  showingAssets: boolean;
}

export interface ProjectApprovalMatrix {
  DocumentId: string;
  ProjectTeam: string;
  ExploreDevelopId: number;
  ProjectTypeId: number;
  ProjectSubTypeId: number;
  AssetTeamId: number;
}

export interface ISmallWell {
  WellId: number;
  Name: string;
  Ssn: string;
  AssetId: number;
  DrillDesignId: number;
  DevelopmentAreaId: number;
  TypeCurveAreaId: number;
  Asset: ISmallAsset;
}

export interface ISmallScWell {
  Well: ISmallWell;
  DrillDesignId: number;
}

export interface ISmallAsset {
  AssetName: string;
  DevelopmentAreaId: number;
  TypeCurveAreaId: number;
}

export interface TypeSubType {
  ProjectTypeId: number;
  ProjectSubTypeId?: number | null;
  FunctionId: number;
}

export interface AssetWell {
  WellId: number;
  Ssn: string;
  Name: string | null;
  OWID: number | null;
  PadId: number | null;
  ScenarioId: number;
  AssetId: number;
  AssetName: string | null;
  DrillDesignId: number;
  WellProfileId: number;
  WellProfileName: string;
  DevelopmentAreaId: number;
  TypeCurveAreaId: number;
  AssetTeamId: number;
  TankBatteryAreaId: number | null;
  IsInsideCityLimits: number | null;
  CountyId: number | null;
  County: number | null;
  StateId: string;
  State: string;
  AssetTypeId: number;
  AssetType: string;
  AssetSuperTypeId: 50;
  AssetSuperType: string;
  CostCenterId: number | null;
  CostCenterNumber: number | null;
  CostCenter: string | null;
  ActualNetWorkingInterest: number | null;
  EstimatedNetWorkingInterest: number | null;
  PreliminaryNetWorkingInterest: number | null;
  TargetFormation: string;
  ProjectIds: string;
  ProjectTypes: string;
}

export interface BatteryDesignType {
  BatteryDesignTypeId: number;
  Description: string;
}